import React, { useEffect, useState } from "react";
import { adminAxios } from "../api";
import { Loader2, Search } from "lucide-react";
import { Input } from "../../components/ui/input";

const payColor = (s) => ({ paid: "bg-emerald-100 text-emerald-700", pending: "bg-amber-100 text-amber-700", failed: "bg-red-100 text-red-700", created: "bg-slate-100 text-slate-600" }[s] || "bg-slate-100 text-slate-600");

const PaymentsAdmin = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = {}; if (q) params.q = q; if (status) params.status = status;
      setRows((await adminAxios.get("/payments", { params })).data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const cur = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900 mb-1">Payments &amp; Transactions</h1>
      <p className="text-slate-500 mb-6">Online (Razorpay) transaction records</p>
      <div className="flex flex-wrap gap-3 mb-4">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search ref / payment id / name" className="pl-9 w-72" />
        </form>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="border border-slate-200 rounded-md px-3 text-sm bg-white">
          <option value="">All statuses</option>
          {["created", "pending", "paid", "failed"].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      {loading ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-slate-400 animate-spin" /></div> : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-left"><tr>
              <th className="px-4 py-3 font-medium">Order Ref</th><th className="px-4 py-3 font-medium">Customer</th><th className="px-4 py-3 font-medium">Amount</th><th className="px-4 py-3 font-medium">Gateway</th><th className="px-4 py-3 font-medium">Payment ID</th><th className="px-4 py-3 font-medium">Status</th><th className="px-4 py-3 font-medium">Date</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((p) => (
                <tr key={p.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 font-medium text-slate-800">{p.order_ref}</td>
                  <td className="px-4 py-3">{p.customer_name}</td>
                  <td className="px-4 py-3">{cur(p.amount)}</td>
                  <td className="px-4 py-3 capitalize">{p.gateway}</td>
                  <td className="px-4 py-3 text-xs text-slate-500 break-all">{p.gateway_payment_id || "—"}</td>
                  <td className="px-4 py-3"><span className={`px-2 py-1 rounded-full text-xs ${payColor(p.status)}`}>{p.status}</span></td>
                  <td className="px-4 py-3 text-slate-500">{new Date(p.created_at).toLocaleDateString("en-IN")}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={7} className="text-center py-10 text-slate-400">No transactions yet. Online transactions appear here once Razorpay is configured.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PaymentsAdmin;
